import React, { useEffect, useRef } from "react";

/**
 * Campo-armadilha anti-spam (honeypot). Invisível para pessoas e para leitores
 * de ecrã; robôs que preenchem todos os campos são silenciosamente ignorados
 * pelo backend (campo "website").
 *
 * - `inputRef`: ref para o <input> (ler `inputRef.current?.value` no envio).
 * - `valueRef` (opcional): guarda o valor mesmo depois de o campo desmontar —
 *   útil nos wizards em que o formulário de identidade é um passo anterior ao
 *   envio (o campo já não existe no DOM quando se submete). "Pegajoso": depois
 *   de preenchido nunca volta a vazio.
 */
export default function Honeypot({ inputRef, valueRef }) {
  const elRef = useRef(null);

  const setRef = (el) => {
    elRef.current = el;
    if (!inputRef) return;
    if (typeof inputRef === "function") inputRef(el);
    else inputRef.current = el;
  };

  useEffect(() => {
    const el = elRef.current;
    return () => {
      // Captura preenchimentos programáticos (sem evento) ao desmontar
      if (valueRef && el && el.value) valueRef.current = el.value;
    };
  }, [valueRef]);

  return (
    <div
      aria-hidden="true"
      style={{ position: "absolute", left: "-10000px", top: "auto", width: 1, height: 1, overflow: "hidden" }}
    >
      <label>
        Website
        <input
          ref={setRef}
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          defaultValue=""
          data-testid="hp-website"
          onChange={(e) => {
            if (valueRef && e.target.value) valueRef.current = e.target.value;
          }}
        />
      </label>
    </div>
  );
}

/** Valor a enviar no campo `extra.website` (input montado ou valor guardado). */
export function honeypotValue(inputRef, valueRef) {
  return inputRef?.current?.value || valueRef?.current || "";
}
